/**
 * When to refresh the saved copies: when the app starts, comes to the front, or the network
 * returns — the moments a scorer is about to look at something and the signal is known to be
 * there. The throttle lives in `ReadCache.refreshRecent`, so calling this often is safe.
 */
import type { ForegroundEnv } from "../sync/foreground.ts";

export function startCacheRefresh(
  refresh: () => Promise<void>,
  env: Pick<ForegroundEnv, "window" | "document">,
): () => void {
  const run = (): void => {
    void refresh().catch(() => undefined);
  };
  const onVisibility = (): void => {
    if (env.document.visibilityState === "visible") run();
  };

  run();
  env.window.addEventListener("online", run);
  env.document.addEventListener("visibilitychange", onVisibility);
  return () => {
    env.window.removeEventListener("online", run);
    env.document.removeEventListener("visibilitychange", onVisibility);
  };
}
